import React from 'react'
// components
import { useLocation, useNavigate } from 'react-router'
import { Result, Button, Typography } from 'antd'
import { HomeOutlined } from '@ant-design/icons'

function NotFound() {
    const location = useLocation()
    const navigate = useNavigate()

    return (
        <Result
            status="404"
            title="404"
            subTitle={
                <Typography>
                    Parece que <b>{location.pathname}</b> não é um caminho válido.
                </Typography>
            }
            extra={
                <Button icon={<HomeOutlined />} onClick={() => navigate('/reports')}>
                    Voltar ao Início
                </Button>
            }
        />
    )
}

export default NotFound;
